import React from 'react';
import { useParams } from 'react-router-dom';
import { getGameConfig } from '../games';
import { useGameplaySession } from '../hooks/useGameplaySession';
import { GameStatus } from '../types/gameplay';
import SerpentoniGame from './SerpentoniGame';

const Serpentoni = () => {
  const { date } = useParams();
  const gameConfig = getGameConfig('serpentoni');

  const {
    puzzleConfig,
    state: sessionState,
    solutions,
    status,
    gameOver,
    won,
    lost,
    justWon,
    justLost,
    isLoading,
    error: sessionError,
    isEventPending,
    dispatchEvent,
    dispatchHintEvent,
    hintAllowance,
    refreshHintAllowance,
    isSignedIn,
  } = useGameplaySession(gameConfig.id, date, {
    deriveStatusFromLocalStorage: (data) => {
      if (!data) return GameStatus.NOT_STARTED;

      const foundWordIndices = data.found_word_indices || data.foundWordIndices || [];
      const spangramFound = data.spangram_found || data.spangramFound || false;
      const lives = typeof data.lives === 'number' ? data.lives : 10;
      const status = data.status;

      if (data.player_won || data.playerWon || status === GameStatus.WON) {
        return GameStatus.WON;
      }

      if (data.game_over || data.gameOver || lives <= 0 || status === GameStatus.LOST) {
        return GameStatus.LOST;
      }

      if (
        (typeof data.seq === 'number' && data.seq > 0) ||
        foundWordIndices.length > 0 ||
        spangramFound ||
        lives < 10 ||
        status === GameStatus.IN_PROGRESS
      ) {
        return GameStatus.IN_PROGRESS;
      }

      return GameStatus.NOT_STARTED;
    },
  });

  return (
    <SerpentoniGame
      key={sessionState?.session_id || date}
      date={date}
      gameConfig={gameConfig}
      puzzleConfig={puzzleConfig}
      sessionState={sessionState}
      solutions={solutions}
      status={status}
      gameOver={gameOver}
      won={won}
      lost={lost}
      justWon={justWon}
      justLost={justLost}
      isLoading={isLoading}
      sessionError={sessionError}
      isEventPending={isEventPending}
      dispatchEvent={dispatchEvent}
      dispatchHintEvent={dispatchHintEvent}
      hintAllowance={hintAllowance}
      refreshHintAllowance={refreshHintAllowance}
      isSignedIn={isSignedIn}
    />
  );
};

export default Serpentoni;
